import { $, $$ } from '@3pc/dom';
import { ClickRedirect } from '@3pc/click-redirect';

const listTeasers = $$('.header-teaser');

if (listTeasers.length) {
  listTeasers.forEach(teaser => {
    // Get references to the source and target elements
    const targetElement = $('.header-teaser__link', teaser);
    const sourceImage = $('.header-teaser__picture', teaser);
    const sourceText = $('.header-teaser__text', teaser);
    const sourceElements = [sourceImage, sourceText].filter(Boolean); // Remove null/undefined elements

    // Define configuration options
    const config = {
      preventDefault: false, // Prevent the default click behavior
    };

    if (!targetElement) return;

    sourceElements.forEach(source => {
      const instanceClickRedirect = new ClickRedirect(
        source,
        targetElement,
        config
      );

      instanceClickRedirect.activate();
    });
  });
}
